import { GTMEvent } from '@/utils/gtm'
import Anchor from '../anchor'
import Icon from '../icon'

import { IconListItemProps } from './types'
import { useApp } from '@wap-client/core'
import { Akiva } from '@/utils/akiva/akiva'
import { AkivaType } from '@/utils/akiva/types'

const IconListItem: React.FunctionComponent<IconListItemProps> = (props) => {
  const { icon, text, anchor, ...rest } = props
  const app = useApp()

  const onInteract = () => {
    let event = {}

    event = {
      social_media: text,
    }

    GTMEvent('social-media-view', event, app)
    Akiva({ app, type: AkivaType.Social })
  }

  const Body = () => {
    if (text) {
      return (
        <>
          <span>
            <Icon {...icon} />
          </span>
        </>
      )
    }

    return <Icon {...icon} />
  }

  if (anchor) {
    return (
      <Anchor
        className="c-iconlist-item-anchor"
        title={text}
        onClick={() => onInteract()}
        {...anchor}
      >
        <Body />
      </Anchor>
    )
  }

  return (
    <div
      className="c-iconlist-item"
      {...rest}
      role="button"
      tabIndex={0}
      onClick={onInteract}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onInteract()
        }
      }}
    >
      <Body />
    </div>
  )
}

export default IconListItem
